export default __webpack_public_path__ + "static/media/30.a0b3e61a.jpg";